import axios from "axios";
import { toast } from "react-toastify";
import { errorMessage } from "../utils/messages";

axios.defaults.headers.post["Content-Type"] = "application/json";

const token = localStorage.getItem("token");

if (token) axios.defaults.headers.common["x-access-token"] = `${token}`;

axios.interceptors.response.use(null, (error) => {
  const expectedErrors =
    error.response &&
    error.response.status >= 400 &&
    error.response.status < 500;
  if (!expectedErrors) {
    console.log(error);
    toast.error("مشکلی در دریافت اطلاعات رخ داد", {
      position: "top-right",
      closeOnClick: true,
    });
  }
  if (error.response.status === 401) {
    errorMessage("مشکلی در احراز هویت رخ داده! مجددا وارد شوید.");
  }
  return Promise.reject(error);
});

export default {
  get: axios.get,
  post: axios.post,
  put: axios.put,
  delete: axios.delete,
};
